<template>
    <div id="contact-area" class="fixed-bottom d-flex justify-content-end align-items-center m-3 ml-auto">

        <span class="mr-1 animated fadeIn"  v-if="isScrollMounted">
            <fab
                :bgColor="bgColor"
                :actions="fabActions"
                @fabEmail="fabEmail"
                @fabPhone="fabPhone">

            </fab>
        </span>
    </div>
</template>

<script>


export default {

    components: {
        fab: require('./Fab.vue')
    },

    mounted(){

        let activeContactArea = () => {
            this.isScrollMounted = true;
            window.removeEventListener('scroll', activeContactArea);
        }



    },

    data(){
        return {
            isScrollMounted: true,
            bgColor: "#8A8D8E",
            fabActions: [
                {
                    name: 'fabPhone',
                    icon: 'icon-phone'
                }
                // {
                //     name: 'fabEmail',
                //     icon: 'icon-social-mail'
                // },
            ]
        }
    },

    methods: {
        fabEmail() {
            bus.$emit('openContactModalBox', true);
        },

        fabPhone() {
            // ga('send', 'event', 'widget', 'llamar', null, 1);
            document.location.href = "tel:+34914314597";
        }
    }
}
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #contact-area {
        color: white;
        border-radius: 3rem;
        transition: width .4s linear .4s;
        min-width: 2.5rem;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ContactAreaButton.vue